var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-xs"},[_c('span',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.label)+" ")]),(_vm.required)?_c('span',{staticClass:"has-text-danger"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }